import { Button } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';

const BtnLogOut = () => {

  const handleLogout = () => {
    sessionStorage.removeItem('ebt_token_unidades_detenidas');
    window.location.replace("https://ebtapps.com/");
  };

  return (
    <Button
      color="inherit"
      onClick={handleLogout}
      startIcon={<LogoutIcon />}
    >
      Salir
    </Button>
  );
};

export default BtnLogOut;
